import set from 'lodash/fp/set';
import mapValues from 'lodash/mapValues';
import toPairs from 'lodash/toPairs';
import maxBy from 'lodash/maxBy';

import BIDS from './types';
import getStorageValue from '~/misc/getStorageValue';
import safeJSONParse from '~/misc/safeJSONParse';
import toLegacyLoad from '~/misc/toLegacyLoad';
import resourceId from '~/misc/resourceId';
import get from 'lodash/get';

const getResourceIdentity = (queryCompleted) => resourceId('bids', {
  query: queryCompleted,
});

const markCreatedAt = (since) => {
  const searchSince = new Date(since);
  return (item) => {
    const createdAt = item.created_at || (searchSince - item.age);
    return toLegacyLoad(item, createdAt);
  };
};

const convertToLoads = (list, state) => {
  
  const payloadList = (list || []).map(item => ({
    ...item,
    identity: resourceId('bids', {
      id: item.id,
    }, state.identity),
    parentIdentity: state.identity,
  }));
  return {
    results : {
      hasItems: payloadList.length !== 0,
      shipments: payloadList,
      total: list.length
    }
  }
}


const getSavedBid = (pair) => {
  if (Array.isArray(pair[0])) {
    return getSavedBid(pair[0]);
  }

  return {value: pair[0], counter: (pair[1] || 0)};
};

const getBidded = (savedData) => {
  if (!savedData) {
    return {
      counter: 0,
      index: {},
    };
  }

  const index = mapValues(savedData, (value) => getSavedBid(value));

  const list = toPairs(index);
  const max = maxBy(list, '1.counter');

  const counter = (max && max[1].counter) || 0;

  return {
    index,
    counter,
  };
};

const init = () => {
  const saved = getBidded(safeJSONParse(getStorageValue('madeBids')));
  return {
    counter: saved.counter,
    index: saved.index,
    map: new Map(),
    updatedTime: Date.now(),
    identity: getResourceIdentity(null),
  };
};

const updatedBid = (current, action, counter) => {
  if (action.pending) {
    return {
      ...current,
      counter,
      error: null,
      loading: true,
    };
  }

  if (action.error) {
    return {
      ...current,
      counter,
      loading: null,
      error: action.payload.message,
    };
  }

  return {
    ...current,
    loading: null,
    counter,
    value: action.payload.offer_amount,
    success: true,
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    /* case BIDS.BIDS_MADE: {
      const {loadId} = action.meta;
      const item = state.index[loadId] || {};

      const counter = state.counter + 1;
      const updated = updatedBid(item, action, counter);

      return {
        ...set(
          ['index', loadId],
          updated,
          state
        ),
        counter: counter,
      };
    } */
    case BIDS.BIDS_GET: {
      if (action.error || action.pending) return state;
      //const list = convertToLoads ( action.payload.data.resultList.map(({shipment})=>markCreatedAt(Date.now())(shipment)), state);
      return {
        map: action.payload.data ? new Map(action.payload.data.resultList.map(({shipment, status, id, priceDollar, status_key, bottom})=>([shipment.id, {status, id, price: priceDollar, bidType: status_key, nextNode: get(bottom, "btn_action"), awardMsg: get(bottom, "msg")} ]))): new Map(),
        updatedTime: Date.now()
      }
    }
    case (BIDS.BIDS_SUCCESS_MESSAGE_READED): {
      const {loadId} = action.payload;
      const item = state.index[loadId] || {};
      return set(
        ['index', loadId],
        {...item, success: null},
        state
      );
    }
  }

  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/bids/reducer.js